(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elena-cart-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
  const drawer = document.getElementById('cart-drawer');
  const banner = drawer?.querySelector('[data-session-countdown]');
  const count = drawer?.querySelector('cart-count');
  if (!drawer || !banner || !count) return;
  const originalMarkup = banner.innerHTML;
  const storageKey = 'agnes_cart_session_v1';
  const duration = 10 * 60 * 1000;
  let deadline = 0;
  let interval;
  try { deadline = Number(localStorage.getItem(storageKey)) || 0; } catch {}
  function tick() {
    if (!deadline) return;
    const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    if (!remaining) {
      banner.textContent = banner.dataset.finishedText;
      clearInterval(interval);
      interval = undefined;
      return;
    }
    const output = banner.querySelector('[data-session-time]');
    if (output) output.textContent = `${String(Math.floor(remaining / 60)).padStart(2, '0')}:${String(remaining % 60).padStart(2, '0')}`;
  }
  function refresh() {
    const quantity = Number(count.dataset.cartCount || count.textContent.trim());
    if (!quantity) {
      deadline = 0;
      clearInterval(interval);
      interval = undefined;
      try { localStorage.removeItem(storageKey); } catch {}
      banner.innerHTML = originalMarkup;
      return;
    }
    if (!drawer.classList.contains('is-open')) return;
    if (!deadline) {
      deadline = Date.now() + duration;
      banner.innerHTML = originalMarkup;
      try { localStorage.setItem(storageKey, String(deadline)); } catch {}
    }
    tick();
    if (!interval && deadline > Date.now()) interval = setInterval(tick, 1000);
  }
  new MutationObserver(refresh).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(refresh).observe(count, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cart-count'] });
  document.addEventListener('theme:cart:change', refresh);
  document.addEventListener('visibilitychange', refresh);
  refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elena-footwear-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elena-footwear-guide')) {
    customElements.define('elena-footwear-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('.efc-trigger');
        if (!dialog || !trigger) return;
        trigger.addEventListener('click', () => {
          const scope = this.closest('.selector-wrapper');
          const input = scope?.querySelector('input[data-single-option-selector]:checked, input[type="hidden"][data-single-option-selector], select[data-single-option-selector]');
          const selected = input?.value.trim().replace(',', '.');
          dialog.querySelectorAll('[data-efc-size]').forEach(row => {
            if (row.dataset.efcSize === selected) row.setAttribute('aria-current', 'true');
            else row.removeAttribute('aria-current');
          });
          if (!dialog.open) dialog.showModal();
          dialog.scrollTop = 0;
        });
        this.querySelector('.efc-close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => trigger.focus({preventScroll:true}));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elena-product-dispatch"] && !Shopify.designMode) return;
  try {
    (() => {
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit'
    });
    function updateDispatchDates() {
      const parts = Object.fromEntries(formatter.formatToParts(new Date()).map(part => [part.type, part.value]));
      const tomorrow = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + 1));
      const date = String(tomorrow.getUTCDate()).padStart(2, '0') + '/' + String(tomorrow.getUTCMonth() + 1).padStart(2, '0');
      document.querySelectorAll('[data-dispatch-weekdays]').forEach(strip => {
        const label = strip.querySelector('.agnes-dispatch-strip__estimate strong');
        const days = strip.dataset.dispatchWeekdays.split(',');
        if (label && days.length === 7) label.textContent = days[tomorrow.getUTCDay()].toLocaleUpperCase('ro-RO') + ' ' + date;
      });
    }
    updateDispatchDates();
    document.addEventListener('shopify:section:load', updateDispatchDates);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) updateDispatchDates(); });
    setInterval(updateDispatchDates, 60000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elena-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elena-size-guide')) {
    customElements.define('elena-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('.elena-size-guide__trigger');
        if (!dialog || !trigger) return;
        trigger.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); });
        this.querySelector('.elena-size-guide__close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-collection-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-suggestions')) {
    customElements.define('collection-suggestions', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-collection-track]');
        this.previous = this.querySelector('[data-collection-prev]');
        this.next = this.querySelector('[data-collection-next]');
        this.progress = this.querySelector('[data-collection-progress]');
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), {...options,passive:true});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({left:event.key === 'Home' ? 0 : this.track.scrollWidth,behavior:'auto'});
          else this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        const search = this.closest('[data-popdown]');
        this.empty = this.closest('[data-agnes-empty-search]');
        if (search && this.empty) {
          this.input = search.querySelector('input[type="search"]');
          this.input.addEventListener('input', () => this.syncSearch(), options);
          this.input.addEventListener('focus', () => this.syncSearch(), options);
          this.input.form.addEventListener('reset', () => requestAnimationFrame(() => this.syncSearch()), options);
          this.syncSearch();
        }
        this.update();
      }
      disconnectedCallback() { this.events?.abort(); this.resize?.disconnect(); }
      syncSearch() { this.empty.hidden = Boolean(this.input.value.trim()); }
      move(direction) {
        const card = this.track.querySelector('.collection-suggestions__item');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        const count = Math.max(1, Math.floor(this.track.clientWidth / step));
        this.track.scrollBy({left:direction * step * count,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      update() {
        const width = this.track.clientWidth;
        if (!width) return;
        const max = Math.max(0, this.track.scrollWidth - width);
        const left = Math.min(max, Math.max(0, this.track.scrollLeft));
        this.previous.disabled = left <= 2;
        this.next.disabled = max <= 2 || left >= max - 2;
        this.progress.style.width = `${100 * width / this.track.scrollWidth}%`;
        this.progress.style.left = `${100 * left / this.track.scrollWidth}%`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
